import { render, staticRenderFns } from "./AddressBookByPublicKey.vue?vue&type=template&id=2be13b96&scoped=true&"
import script from "./AddressBookByPublicKey.vue?vue&type=script&lang=js&"
export * from "./AddressBookByPublicKey.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookByPublicKey.vue?vue&type=style&index=0&id=2be13b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be13b96",
  null
  
)

export default component.exports